import React from "react"
import { useSelector } from "react-redux"
import { Navigate } from "react-router-dom"
import { isAdminPortalUser } from "../../helpers/adminRoles"
import {
  getAuthenticatedHomePath,
  hasAuthSession,
  isMemberUser,
} from "../../helpers/routeAccess"

/**
 * Restricts admin routes to platform admin (super_admin / admin) and city_admin.
 */
const AdminMiddleware = ({ children }) => {
  const authToken = useSelector(state => state.auth.jid)
  const currentUser = useSelector(state => state.auth.currentUser)

  if (!hasAuthSession(authToken)) {
    return <Navigate to="/login" replace />
  }

  // Wait for user payload — never redirect null users to /admin/dashboard
  // (that Navigate looped with Authmiddleware / LoginRoute).
  if (!currentUser) {
    return null
  }

  if (isMemberUser(currentUser)) {
    return <Navigate to="/dashboard" replace />
  }

  if (!isAdminPortalUser(currentUser)) {
    return <Navigate to={getAuthenticatedHomePath(currentUser)} replace />
  }

  return children
}

export default AdminMiddleware
